import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

import MeAndMyDirectFamilyDrawer from './MeAndMyDirectFamilyDrawer';
import MyselfFamilyDrawer from './MyselfFamilyDrawer';
import LivesCoveredSideDrawer from './LivesCoveredSideDrawer';
import BenifitsDrawer from './BenifitsDrawer';
import { OmApplicationPopupModal, OmButton, OmIcon } from '@om/component-library-react';
import { getCoverType, getDeleteQuoteDetails } from '@om/redux/selectors/sizotsaFuneralCover/quote';
import { removeMember, setQuoteDetailsStateValue } from '@om/redux/actions/sizotsaFuneralCover/quote';
import { SF_COVER_CATEGORIES } from '@om/redux/actions/sizotsaFuneralCover/types';
import AgentDetailsDrawer from './AgentDetailsDrawer';
import './QuoteModals.scss';

const QuoteModals = () => {
    const dispatch = useDispatch();
    const { deleteQuoteDetails, coverType } = useSelector(
        createStructuredSelector({
            deleteQuoteDetails: getDeleteQuoteDetails,
            coverType: getCoverType,
        })
    );
    return (
        <div className='funeralQuoting'>
            {/* { coverType===SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY&& */}
            <MeAndMyDirectFamilyDrawer />

            {/* } */}
            {/* { coverType===SF_COVER_CATEGORIES.MYSELF&&  */}
            <MyselfFamilyDrawer />
            {/* } */}
            {/* { coverType===SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER&&  */}
            <LivesCoveredSideDrawer />
            {/* } */}
            {/* {coverType===SF_COVER_CATEGORIES.BENIFITS&& */}
            <BenifitsDrawer />
            {/* } */}
            <AgentDetailsDrawer />

            <OmApplicationPopupModal
                dismissible
                name="removeModalQuote"
                open={deleteQuoteDetails}
                closeOnButtonClick={false}
                onModalClosed={() =>
                    dispatch(
                        setQuoteDetailsStateValue({
                            fieldType: 'deleteQuoteDetails',
                            value: null,
                        })
                    )
                }
            >
                <div slot="content">
                    <OmIcon imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/bltc34f1c6e32fb7291/5ec3d2d2a4bead4101d1941f/TrashSVG.svg" />
                    <p>{deleteQuoteDetails?.message}</p>
                </div>
                <div slot="button">
                    <OmButton
                        type="primary"
                        size="small"
                        text="YES, REMOVE"
                        onClick={() => {
                            dispatch(
                                removeMember({ id: deleteQuoteDetails?.id, category: deleteQuoteDetails?.category })
                            )
                            dispatch(
                                setQuoteDetailsStateValue({
                                    fieldType: 'deleteQuoteDetails',
                                    value: null,
                                })
                            )
                        }

                        }
                    />
                </div>
            </OmApplicationPopupModal>
        </div>
    );
};

export default QuoteModals;
